import { createReducer, on } from '@ngrx/store';
import * as fromScheduleActions from '../actions/schedule.action';
export const featureKey = 'schedule';

export interface State {
    generatedSchedules: {
        data: Array<any>,
        isLoaded: Boolean
    };
    generatedScheduleProcessId: any;
    generatedScheduleDetails: {
        data: Array<any>,
        isLoaded: Boolean
    };
    confirmSchedule: {
        data: Array<any>,
        isLoaded: Boolean
    };
    scheduleDetailsOptions: {
        data: Array<any>,
        isLoaded: Boolean
    };
    generatedStudentSchedule: {
        data: Array<any>,
        isLoaded: Boolean
    };
    schedulesUnmatched: {
        data: Array<any>,
        isLoaded: Boolean
    };
}

export const initialState: State = {
    generatedSchedules: {
        data: [],
        isLoaded: false
    },
    generatedScheduleProcessId: null,
    generatedScheduleDetails: {
        data: [],
        isLoaded: false
    },
    confirmSchedule: {
        data: [],
        isLoaded: false
    },
    scheduleDetailsOptions: {
        data: [],
        isLoaded: false
    },
    generatedStudentSchedule: {
        data: [],
        isLoaded: false
    },
    schedulesUnmatched: {
        data: [],
        isLoaded: false
    },
}

export const reducer = createReducer(
    initialState,
    on(fromScheduleActions.getGeneratedSchedulesSuccess, (state: State, props: any) => ({
        ...state,
        generatedSchedules: {data: props.data, isLoaded: true}
    })),
    on(fromScheduleActions.resetGeneratedSchedule, (state) => ({
        ...state,
        generatedSchedules: { ...initialState.generatedSchedules }
    })),
    on(fromScheduleActions.generateScheduleSuccess, (state: State, props: any) => ({
        ...state,
        generatedScheduleProcessId: props.data
    })),
    on(fromScheduleActions.getGeneratedScheduleDetailsSuccess, (state: State, props: any) => ({
        ...state,
        generatedScheduleDetails: { data: props.data, isLoaded: true }
    })),
    on(fromScheduleActions.resetGeneratedScheduleDetails, (state) => ({
        ...state,
        generatedScheduleDetails: { ...initialState.generatedScheduleDetails }
    })),
    on(fromScheduleActions.getScheduleDetailsOptionsSuccess, (state: State, props: any) => ({
        ...state,
        scheduleDetailsOptions: { data: props.data, isLoaded: true }
    })),
    on(fromScheduleActions.confirmSchedule, (state: State, props: any) => ({
        ...state,
        confirmSchedule: { data: props.data, isLoaded: true }
    })),
    on(fromScheduleActions.generateStudentScheduleSuccess, (state: State, props: any) => ({
        ...state,
        generatedStudentSchedule: { data: props.data, student: props.student, schedule: props.schedule, isLoaded: true }
    })),
    on(fromScheduleActions.getSchedulesUnmatchedSuccess, (state: State, props: any) => ({
        ...state,
        schedulesUnmatched: { data: props.data, isLoaded: true }
    })),
);